module.exports = __webpack_public_path__ + "img/icon-eye.1a56ee06.svg";